var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1111 16.6669C14.793 16.6669 17.7778 13.6821 17.7778 10.0002C17.7778 6.31832 14.793 3.33355 11.1111 3.33355C7.42921 3.33355 4.44444 6.31832 4.44444 10.0002H6.12802C6.54205 10.0002 6.80082 10.4211 6.59381 10.7578L3.79911 15.3032C3.5921 15.6399 3.07456 15.6399 2.86755 15.3032L0.0728569 10.7578C-0.134157 10.4211 0.124611 10.0002 0.538639 10.0002H2.22222C2.22222 5.09102 6.20191 1.11133 11.1111 1.11133C16.0203 1.11133 20 5.09102 20 10.0002C20 14.9094 16.0203 18.8891 11.1111 18.8891C10.4975 18.8891 10 18.3916 10 17.778C10 17.1643 10.4975 16.6669 11.1111 16.6669Z",
    fill: "#333F48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.3b5a14def45e22dc88101905325d87d9.svg";
export { ForwardRef as ReactComponent };